import { HostListener, Component, AfterViewInit } from '@angular/core'

import { ControllerService } from '../../services/controller/controller.service'

import { LanguageService } from '../../services/language/language.service'

// Angular modules for stand alone
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';



@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent  implements AfterViewInit {


  // Controll if the header may be hidden
  private headerMayBeHidden:boolean = false


  constructor(public controllerService:ControllerService,
              public languageService:LanguageService){}


  ngAfterViewInit(): void {
    this.subscribeToRouteChanges()
  }


  /* On scroll listener */
  @HostListener('window:scroll', ['$event']) 
  onScroll(event:any) {
    if(this.headerMayBeHidden){
      this.setHeaderOpacity(Math.min(window.scrollY * 5, 100))
    }
  } 


  // Change language
  changeLanguage(){
    this.languageService.updateLanguageFromHeaderButton()
  }
 

  setHeaderOpacity(opacity:number){
    const element = document.getElementById('header')!
    element.style.opacity = opacity.toString()+'%'     
  }

  
  private subscribeToRouteChanges() {
    this.controllerService.getCurrentRoute().subscribe(currentRoute => {
      if (currentRoute === '/') {
        this.headerMayBeHidden = true;
        this.setHeaderOpacity(Math.min(window.scrollY * 5, 100));
      } else {
        this.headerMayBeHidden = false;
        this.setHeaderOpacity(100);
      }
    });
  }

  navigate(route:string){
    this.controllerService.navigate(route)
  }

}
